<div class="blue-feature">
    <app-feature-hero
    variant="ims"
    title="Simplify and Streamline Your Network Event Management"
    description="Identify network events to improve service availability with correlation capabilities & other actionable features."
    image=""
    imageAlt=""
></app-feature-hero>

    <section class="container section-spacing">
        <div class="row mx-0 align-items-center">
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <div class="illustrated-feature-container-text-left">
                    <h2 class="section-title">Eliminate Noise In Complex Networks With Event Management</h2>
                    <p class="section-paragraph">Infraon NMS helps you get to the root cause of network events and arrive at quick and focused resolutions without any misinformation. Significantly reduce event noise in your network with immediate clarity on network device health.</p>
                </div>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <div class="illustrated-feature-container-img-right justify-content-center">
                    <img src="/assets/img/feature-pages/infraon-ims/network-event-management/event-management-main-illustration.svg" width="80%" alt="head office primary">
                </div>
            </div>
        </div>
    </section>

<section class="container section-spacing">
    <div id="gdpr-wrapper">
        <div class="gdpr-section justify-content-center">
            <img src="/assets/img/feature-pages/gdpr.webp" alt="GDPR Logo" class="me-4 w-100">
            <div>
                <h2 class="section-title mb-3">Our Product Suite is GDPR-Compliant</h2>
                <p class="section-paragraph mb-0">We are compliant with the European General Data Protection Regulation (GDPR) – and <br> our SaaS-based product suite is fully committed to protecting the data of our customers <br> as per the recent standards.</p>
            </div>
        </div>
    </div>
</section>



    <section class="container section-spacing">
        <h2 class="section-title text-center p-b-60">Feature Highlights</h2>

        <div class="row mx-0 justify-content-center">
            <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
                <div class="mb-3">
                    <img class="d-block mx-auto" src="/assets/img/feature-pages/infraon-ims/network-event-management/eye.svg" alt="Eye icon">
                </div>

                <p class="section-title-s">Comprehensive Event Visibility</p>
                <p class="section-paragraph-s">Get full transparency & visibility into your network events across a multi-vendor network with alerts/notifications for faults, updates, changes, etc.s to discover the incident sources.</p>
            </div>

            <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
                <div class="mb-3">
                    <img class="d-block mx-auto" src="/assets/img/feature-pages/infraon-ims/network-event-management/alert.svg" alt="Alert icon">
                </div>

                <p class="section-title-s">Intelligent Alerts</p>
                <p class="section-paragraph-s">Extract qualified alerts from unstructured network data by synchronizing event management with inbuilt monitoring capabilities.</p>
            </div>
        </div>

        <div class="row mx-0 justify-content-center">
            <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
                <div class="mb-3">
                    <img class="d-block mx-auto" src="/assets/img/feature-pages/infraon-ims/network-event-management/network.svg" alt="Network connectivity icon.">
                </div>

                <p class="section-title-s">Automated Root Cause Analysis</p>
                <p class="section-paragraph-s">Automate root cause analysis workflows to prioritize issues & enable faster resolution. Enable event correlation & identify upstream or downstream dependencies.s.</p>
            </div>

            <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
                <div class="mb-3">
                    <img class="d-block mx-auto" src="/assets/img/feature-pages/infraon-ims/network-event-management/command-small.svg" alt="Mcbook Command key">
                </div>

                <p class="section-title-s">Automated Remediation</p>
                <p class="section-paragraph-s">Configure alert management workflows based on predefined rules to identify & resolve issues at a quick pace. Create tasks to handle incidents, requests, changes, etc.p>
            </div>
        </div>
    </section>

    <section class="primary-bg">
        <div class="container section-spacing">
            <div class="row mx-0 d-flex align-items-center position-relative overflow-hidden bg-white-dots">
                <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-xs-12 section-spacing">
                    <h2 class="section-title text-white">Other Features</h2>
    
                    <div class="row mx-0 px-0">
                        <ul class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 px-0">
                            <li class="d-flex align-items-center my-3"><img class="me-3" src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon"> <p class="section-paragraph text-white mb-0">Log To Alarm Conversion</p></li>
                            <li class="d-flex align-items-center my-3"><img class="me-3" src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon"> <p class="section-paragraph text-white mb-0">Device Health Monitoring</p></li>
                            <li class="d-flex align-items-center my-3"><img class="me-3" src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon"> <p class="section-paragraph text-white mb-0">Smart Event Correlation</p></li>
                            <li class="d-flex align-items-center my-3"><img class="me-3" src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon"> <p class="section-paragraph text-white mb-0">Event Aggregation</p></li>
                        </ul>
    
                        <ul class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 px-0">
                            <li class="d-flex align-items-center my-3"><img class="me-3" src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon"> <p class="section-paragraph text-white mb-0 fw-bold">Advanced Reporting</p></li>
                            <li class="d-flex align-items-center my-3"><img class="me-3" src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon"> <p class="section-paragraph text-white mb-0 fw-bold">Advanced Dashboards</p></li>
                        </ul>
                    </div>
                </div>
    
                <div class="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-xs-12 key-features-img-box position-absolute" style="right: 0;bottom: 0;"> 
                    <img src="/assets/img/feature-pages/infraon-ims/network-event-management/woman-2.webp" class="w-80" alt="woman pointing at the features image 2">
                </div>
            </div>
        </div>
    </section>

    
<section class="section-spacing bg-grey">
    <div class="container" id="g2-box-wrapper">
        <div class="g2-box justify-content-between">
            <img loading="lazy" src="/assets/img/feature-pages/g2.svg" alt="G2 Logo">
            <p>Already love using our products? Please <br> share your experiences on G2</p>
            <a href="https://www.g2.com/products/infraon-assets/reviews" class="primary-button">Rate us</a>
        </div>
    </div>
</section>
</div>